'use client';
import { SelectedMenus, Template } from '@zeus/shared';
import { memo, useEffect, useState } from 'react';
import Category from '../Category';
import { isBetweenRange } from '../../../../../utils/utils';

interface TemplateMenu {
  menu: SelectedMenus | null;
  template: Omit<Template, 'content'>;
  development?: boolean;
  timezone?: string;
  scale?: number;
}

const Menu = ({ menu, template, development, timezone, scale = 1 }: TemplateMenu) => {
  const [active, setActive] = useState<boolean | null>(true);

  useEffect(() => {
    if (!development) {
      const intervalId = setInterval(() => {
        setActive(isBetweenRange(menu?.schedules, timezone));
      }, 10000);

      return () => clearInterval(intervalId);
    }
  }, []);

  const isDevelopment = development ? true : isBetweenRange(menu?.schedules, timezone);
  const categories = menu?.categories;
  const fontFamily = template?.fontFamilyName;

  return (
    active && (
      <>
        {isDevelopment &&
          categories?.map((category, categoryIndex) => (
            <Category
              key={`${category.id}-${active}`}
              category={category}
              categoryIndex={categoryIndex}
              template={template}
              development={development}
              timezone={timezone}
              scale={scale}
              fontFamily={fontFamily}
            />
          ))}
      </>
    )
  );
};

export default memo(Menu);
